import { BlocksIconPerson } from 'blocks-nextjs/blocks-web-components/components/icon/icons/person';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconPerson = createComponent({ react: React, tagName: 'cat-icon-person', elementClass: BlocksIconPerson });
